import { Platform } from '@angular/cdk/platform';
import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LayoutService {
    constructor(private platform: Platform) {
        this.safeArea.next();
    }
    private safeArea: EventEmitter<number> = new EventEmitter<number>();
    isKeyUp: boolean = false;
    oldHeight = window.innerHeight;
    deviceOriantation = this.platform.ANDROID ? screen.orientation.type : '';

    getKeyStatus() {
        return this.isKeyUp;
    }
    public setSafeArea(keyUp: boolean = false) {
        this.adjustHeightOfPage(keyUp);
    }

    public onSafeAreaChange() {
        return this.safeArea.asObservable();
    }
    adjustHeightOfPage(keyUp: boolean) {
        const windowHeight = window.innerHeight;
        const headerHeight = document.getElementById('header')?.offsetHeight;
        this.showFooter();
        if (headerHeight)
            this.safeArea.next(90 - (headerHeight / windowHeight) * 100);
    }

    hideAndShowFooter(height: number, orientation: string = '') {
        const windowHeight = window.innerHeight;
        const headerHeight = document.getElementById('header')?.offsetHeight;
        if (this.platform.ANDROID) {
            if (windowHeight && headerHeight) {
                if (orientation == this.deviceOriantation) {
                    if (this.oldHeight > height) {
                        this.hideFooter();
                        this.safeArea.next(
                            100 - (headerHeight / windowHeight) * 100
                        );
                    } else {
                        this.showFooter();
                        this.safeArea.next(
                            90 - (headerHeight / windowHeight) * 100
                        );
                    }
                } else {
                    this.deviceOriantation = orientation;
                    this.oldHeight = height;
                    this.showFooter();
                    this.safeArea.next(
                        90 - (headerHeight / windowHeight) * 100
                    );
                }
            }
        } else if (this.platform.IOS) {
            if (windowHeight && headerHeight) {
                if (this.oldHeight > height) {
                    this.safeArea.next(
                        100 - (headerHeight / windowHeight) * 100
                    );
                } else {
                    this.safeArea.next(
                        90 - (headerHeight / windowHeight) * 100
                    );
                }
            }
        } else {
            this.showFooter();
            if (headerHeight)
                this.safeArea.next(90 - (headerHeight / windowHeight) * 100);
        }
    }
    hideFooter() {
        document
            .getElementById('footer')
            ?.setAttribute('style', `display:none`);
    }
    showFooter() {
        // if (this.oldHeight != window.innerHeight)
        document
            .getElementById('footer')
            ?.setAttribute('style', `display:block`);
    }
}
